import { AxiosResponse } from 'axios'

const STATUS_ERRORS = {
  401: 'entre em contato com o administrador e',
  404: 'houve um erro interno.',
  403: 'usuário não autorizado,',
  408: 'tempo de resposta excedido,',
}

function parseError(status: number, requestResponse?: AxiosResponse | undefined) {
  const verifyUserConnection = !requestResponse && status !== 500
  if (verifyUserConnection) {
    return 'Erro ao executar o processo, verifique sua conexão com a internet!'
  }

  const validationError = requestResponse?.data?.Errors?.[0]?.ErrorMessage as string
  if (validationError) return `Erro ao executar o processo. ${validationError}`

  return `Erro ao executar o processo, ${
    STATUS_ERRORS[status as keyof typeof STATUS_ERRORS] || ''
  } tente novamente mais tarde!`
}

export { parseError }
